module.exports = __webpack_public_path__ + "img/17.bcfe96c4.svg";